<template>
  <div class="d-flex">
    <p
      class="d-flex align-items-center mb-0 mt-2"
    >
      {{ time }}
    </p>
    <!-- <icon
      v-if="progress"
      type="ios-call"
      class="digit"
      color="red"
      :size="size"
      @click="hangup"
    /> -->
  </div>
</template>

<script>
  import { ASTERISK_INSTANSE } from '@shared/helpers/env';
  import moment from 'moment-es6';
  export default {
    props: {
      size: {
        type: Number,
        default: 40
      }
    },
    data() {
      return {
        progress: true,
        phone: null,
        server: ASTERISK_INSTANSE,
        call_start: null,
        time: null,
        interval: null
      }
    },
    created() {
      this.$eventHub.$on('hanging', this.hangup)
    },
    mounted() {
      this.call_start = Date.now();
      this.timer()
    },
    beforeDestroy() {
      this.hangup();
    },
    methods: {
      hangup() {
        this.$eventHub.$emit('hangup');
        this.time = null;
        this.progress = false;
        clearInterval(this.interval)
      },
      timer() {
        let time;
        this.interval = setInterval(()=>  {
          time = Date.now() - this.call_start;
          this.time = moment(time).format('mm:ss');
        }, 1000)
      }
    } 
  }
</script>

<style lang="scss">
  .tab-row {
    margin: 0 auto;
    width: 280px;
    clear: both;
    text-align: center;
    font-family: 'Exo';
  }

  .digit,
  .dig {
    float: left;
    width: 85px;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .sub {
    font-size: 0.8rem;
    color: grey;
  }

  .tab-container {
    background-color: white;
    position: relative;
    right: 0;
    width: 320px;
    padding: 20px;
    margin: 0px auto;
    height: 420px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  #output {
    font-family: "Exo";
    font-size: 2rem;
    height: 60px;
    font-weight: bold;
    color: #1976d2;
  }

  #call {
    display: inline-block;
    background-color: #66bb6a;
    padding: 4px 30px;
    margin: 10px;
    color: white;
    border-radius: 4px;
    cursor: pointer;
  }

  .botrow {
    margin: 0 auto;
    width: 280px;
    clear: both;
    text-align: center;
    font-family: 'Exo';
  }

  .digit:active,
  .dig:active {
    background-color: #e6e6e6;
  }

  #call:hover {
    background-color: #81c784;
  }

  .dig {
    float: left;
    padding: 10px 20px;
    margin: 10px;
    width: 30px;
    cursor: pointer;
  }
  .ivu-tabs.sip {
    position: absolute;
    right: 0;
    top: 30px;
    width: 320px;
    .ivu-tabs-bar {
      margin-bottom: 0;
    }
  }
  .font-size-22 {
    font-size: 22px;
  }
</style>
